<footer class="footer-area">
  <div class="container">
    <div class="footer-content">
      <div class="footer-brand">
        <h3><a routerLink="/">CidHum</a></h3>
        <p>© Universidad del Norte</p>
      </div>
      <ul class="social-links">
        @for (link of footerLinks; track link) {
          <li>
            <a [href]="link.url" target="_blank" rel="noopener noreferrer">
              <i [class]="iconClass(link.icon)" aria-hidden="true"></i>
              <span>{{ link.label }}</span>
            </a>
          </li>
        }
      </ul>
    </div>
  </div>
</footer>

<ngx-scrolltop backgroundColor="var(--mainColor)" symbolColor="#ffffff"></ngx-scrolltop>
